export default "__VITE_ASSET__B$tg6Gij__"